import PendoToggle from '../../toggle/pendo-toggle.vue.js';

var script = {
  name: 'PendoToggleCell',
  components: {
    PendoToggle
  },
  inject: ['$table'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allowAnimations: false
    };
  },
  methods: {
    handleToggleChange() {
      this.$emit('toggle-change', {
        row: this.row,
        value: !this.value
      });
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-toggle-cell.vue2.js.map
